import { createContext, useState, useEffect } from "react";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem("access_token"));

  const loginUser = (jwt) => {
    localStorage.setItem("access_token", jwt.data.token);
    localStorage.setItem("refresh_token", jwt.refreshToken);
    localStorage.setItem("roles", JSON.stringify(jwt.data.roles ?? []));
    setToken(jwt.accessToken);
  };

  const logoutUser = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("roles");
    setToken(null);
  };

  return (
    <AuthContext.Provider value={{ token, loginUser, logoutUser }}>
      {children}
    </AuthContext.Provider>
  );
};
